
import React from 'react';
import { motion } from 'framer-motion';

import carexIcon from 'assets/images/carexIcon.png';
const CustomLoading = () => {
  const outerCircleVariants = {
    animate: {
      rotate: 360,
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "linear"
      }
    }
  };

  const innerCircleVariants = {
    animate: {
      rotate: -360,
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: "linear"
      }
    }
  };

  return (
    <div className="bg-[#18202E]/80 backdrop-blur-sm z-50">
        <motion.div 
          variants={outerCircleVariants}
          animate="animate"
          
          style={{
            position: 'absolute',
            width: '210px',
            height: '210px',
            borderRadius: '50%',
            border: '8px solid #00C8DA',
            borderTopColor: 'transparent',
            borderLeftColor: 'transparent'
          }}
        />
        <motion.div 
          variants={innerCircleVariants}
          animate="animate"
          style={{
            position: 'absolute',
            width: '150px',
            height: '150px',
            margin: '30px',
            borderRadius: '50%',
            border: '8px solid rgba(24, 32, 46, 0.8)',
            
            borderTopColor: 'transparent',
            borderLeftColor: 'transparent'
          }}
        />
        <img 
          src={carexIcon} 
          alt="Carex Logo"
          style={{
            margin: '55px',
            objectFit: 'contain',
            zIndex: 10,
            position: 'absolute',
            width: '100px',
            height: '100px',
            borderRadius: '50%',
          }}
        />
    </div>
  );
};

export default CustomLoading;